
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activity/voucher",
      function () {
        return require("private-next-pages/activity/voucher.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activity/voucher"])
      });
    }
  